import logo from "../Assets/roctect-logo-2019-1.svg";

const Logo =  () => {

    return (
        <div className="logo">
            <img src={logo} alt="" />
        </div>
    );
}


export default Logo;